

export class AuthenticateModel {

    authorise: Authorise = new Authorise();
}
export class Authorise {
    username: string;
    password: string;
    deviceid: string;
}
